import React, { Component } from 'react';
import InwardingApiHandlerTest from '../../../InwardingApiHandlerTest';
import CircularProgress from '@material-ui/core/CircularProgress';
import ErrorBox from '../../../../../commons/ErrorBox';
import Collapse from '@material-ui/core/Collapse';
import ListingProductTest from '../ListingProductTest';
import info from './../../../../../assets/img/info-button.png';
import close from './../../../../../assets/img/close.png';
import { Dialog } from '@material-ui/core';
import InputFloating from './../../../../../commons/InputFloating.js';

export default class SelectFreebieTest extends Component {
    constructor(props) {
        super(props);
        this.state = {
            freebieListings: [],
            loading: false,
            error: '',
            offerJpin: props.jpin,
            parentListingId: props.listingId,
            parentListingTitle: props.parentListingTitle,
            vinv: props.vinv,
            palletId: props.palletId,
            inactiveOpen: false,
            atleastOneActive: false,
            atleastOneInactive: false,
            createNewListing: false,
            mrp: ''
        }
    }

    componentDidMount = () => {
        this.getFreebieListings();
    }

    getFreebieListings = () => {
        const { vinv, offerJpin } = this.state;
        this.setState({ loading: true });
        InwardingApiHandlerTest.callFreebielistingApi(offerJpin, vinv)
            .then(resp => {
                if (resp) {
                    this.setListingDataAndShowIt(resp);
                }
            }).catch(error => {
                this.setState({ error: error.error.error });
            })
            .finally(e => {
                this.setState({ loading: false });
            })
    }

    setListingDataAndShowIt = (response) => {
        let x = false, y = false;
        if (response) {
            let listings = response.listingInformations;
            if (listings && listings.length > 0) {
                listings.forEach((i, index) => {
                    i['productInfoResponse'] = response.productInfoResponse;
                    if (i.status === "INACTIVE") {
                        y = true;
                    }
                    else {
                        //active, onboarding
                        x = true;
                    }
                })
            }
            this.setState({ freebieListings: listings, atleastOneActive: x, atleastOneInactive: y });
        }
    }

    freebieSelectedEvent = (product) => {
        const { vinv, palletId, parentListingId } = this.state;
        let req = {
            product_name: product.productInfoResponse.title,
            jpin: product.productInfoResponse.jpin,
            mrp: product.mrp,
            status: product.status,
            inwarding_session_id: vinv,
            gric: palletId,
            freebie_listing_id: product.listingId,
            parent_listing_id: parentListingId
        }
        this.props.triggerEvent('ON_SELECT_FREEBIE_PRODUCT_LISTING', req);
    }

    goToFreebieCountingScreen = (product) => {
        this.freebieSelectedEvent(product);

        //to keep the same format for displaying image and title
        if (product.productInfoResponse && product.productInfoResponse.imageUrls) {
            product.capturedFrontSideImageUrl = product.productInfoResponse.imageUrls[0].thumbnail;
            product.productTitle = product.productInfoResponse.title;
        }

        this.props.history.push({
            pathname: '/Inwarding/FreebieDetails',
            state: {
                freebieType: 'existing',
                vinv: this.state.vinv,
                palletId: this.state.palletId,
                parentListingId: this.state.parentListingId,
                parentListingTitle: this.state.parentListingTitle,
                freebieJpin: product.productInfoResponse.jpin,
                data: product
            }
        });
    }

    closeCreateListingBox = () => {
        this.setState({ createNewListing: false });
    }

    showNewlyAddedListing = (listing) => {
        let o = listing.listingInformation;
        o.status = "ACTIVE";
        o.productInfoResponse = listing.productInfoResponse;
        o.new = true;
        let all = this.state.freebieListings;
        all.unshift(o);
        this.setState({ freebieListings: all, createNewListing: false })
        document.getElementById('freebieListingsID').scrollTop = 0;
    }

    createNewListingClicked = () => {
        const { vinv, mrp, offerJpin, palletId, parentListingId, parentListingTitle } = this.state;
        let req = {
            vendorInvoiceId: vinv,
            manufacturerOfferRequest: null,
            mrp: mrp,
            jpin: offerJpin
        }

        this.props.triggerEvent('ON_CLICK_CREATE_NEW_LISTING_FREEBIE', {
            jpin: offerJpin,
            mrp: mrp,
            inwarding_session_id: vinv,
            gric: palletId,

            parent_listing_id: parentListingId ? parentListingId : null,
            parent_listing_title: parentListingTitle ? parentListingTitle : null,

        });

        this.setState({ loading: true, createNewListing: false });
        InwardingApiHandlerTest.createNewListing(req)
            .then(resp => {
                this.showNewlyAddedListing(resp);
            }).catch(error => {
                this.setState({ error: error.error.error });
            }).finally(() => {
                this.setState({ loading: false })
            })
    }

    render() {
        const { loading, freebieListings, atleastOneActive, atleastOneInactive, inactiveOpen, error, createNewListing, mrp } = this.state;
        return (
            <div>
                <div style={{ padding: '10px 20px', textAlign: 'center' }}>
                    {/* heading and line */}
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                        <div className="dc-num">Please select the freebie listing from the following list:</div>
                        <img src={close} style={{ height: '23px', margin: '2px 0px 0px 5px' }} onClick={this.props.onClose} alt='Img' />
                    </div>
                    <div style={{ borderBottom: '2px solid #dfdfdf', marginTop: '10px' }}></div>

                    {/* main content */}
                    {(loading) ?
                        <div style={{ padding: '20px' }} >
                            <CircularProgress style={{ color: '#000' }} size={23} thickness={3} />
                        </div>
                        :
                        <div id="freebieListingsID" style={{ maxHeight: '410px', overflowY: 'scroll' }}>
                            {(freebieListings.length > 0) ?
                                <React.Fragment>
                                    {/* display active listings */}
                                    {atleastOneActive ?
                                        <div style={{ width: '100%', padding: '15px 10px', fontSize: '15px', backgroundColor: '#fbfffb' }}>Choose from below <span style={{ color: '#03aa03' }}>Active</span> Listings</div>
                                        :
                                        null
                                    }
                                    <div>
                                        {freebieListings.map((a, index) => {
                                            if (a.status !== "INACTIVE") {
                                                return <div key={index} style={{ border: '1px solid #e4e4e4', borderRadius: '5px' }}><ListingProductTest product={a} showQty={false} onClick={() => { this.goToFreebieCountingScreen(a) }} /></div>;
                                            }
                                            else {
                                                return null;
                                            }
                                        })}
                                    </div>

                                    {/* display inactive listings in collapsable form */}
                                    {atleastOneInactive ?
                                        <div style={{ width: '100%', padding: '15px 10px', fontSize: '15px', marginTop: '20px', backgroundColor: 'snow' }} onClick={() => { this.setState({ inactiveOpen: !inactiveOpen }) }}>Choose from below <span style={{ color: '#aa0303' }}>Inactive</span> Listings {inactiveOpen ? <i className="fas fa-chevron-up" style={{ marginLeft: '5px' }}></i> : <i className="fas fa-chevron-down" style={{ marginLeft: '5px' }}></i>}</div>
                                        :
                                        null
                                    }
                                    <Collapse in={inactiveOpen}>
                                        <div>
                                            {freebieListings.map((a, index) => {
                                                if (a.status === "INACTIVE") {
                                                    return <div key={index} style={{ border: '1px solid #e4e4e4', borderRadius: '5px' }}><ListingProductTest product={a} showQty={false} onClick={() => { this.goToFreebieCountingScreen(a) }} /></div>;
                                                }
                                                else {
                                                    return null;
                                                }
                                            })}
                                        </div>
                                    </Collapse>
                                </React.Fragment>
                                :
                                <div style={{ padding: '50px 30px', color: '#BD2E23', display: 'flex', alignItems: 'center' }}>
                                    <img src={info} style={{ height: '21px', marginRight: '10px' }} alt='Img' />
                                    <div>No Freebie Listings available</div>
                                </div>
                            }
                        </div>
                    }
                </div>

                <div style={{ display: 'flex', justifyContent: 'center', padding: '0px 20px 10px 20px', backgroundColor: '#e4e4e4', borderTop: '2px solid #c2c2c2' }}>
                    <button className="btn btn-big-norm" style={{ marginTop: '10px', width: '80%' }} onClick={() => { this.setState({ createNewListing: true }) }}>Create new listing for this freebie</button>
                </div>

                <Dialog open={createNewListing} maxWidth="lg" fullWidth={true} onClose={this.closeCreateListingBox} classes={{ 'paper': 'tw-margn-class' }}>
                    <div style={{ padding: '20px', textAlign: 'center' }}>
                        <InputFloating type="number" label="MRP" value={mrp} onChange={(e) => { this.setState({ mrp: e.target.value }) }} />
                        <div style={{ display: 'flex', justifyContent: 'space-evenly', marginTop: '80px' }}>
                            <button className="btn" onClick={this.closeCreateListingBox}>Cancel</button>
                            <button disabled={!mrp} className="btn btn-jt-green" onClick={this.createNewListingClicked}>Create New Listing</button>
                        </div>
                    </div>
                </Dialog>

                {/* display errors from api failures */}
                {(error) ?
                    <ErrorBox errorText={error} closeError={() => { this.setState({ error: '' }) }} /> : null
                }
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/screens/InwardingTest/ComponentsTest/CommonsTest/AddPalletUITest/SelectFreebieTest.js